import { theme } from 'lib/theme';
import React from 'react';
import { Insets, StyleProp, ViewStyle } from 'react-native';
import { KeyboardAwareScrollViewProps } from 'react-native-keyboard-controller';
import type { KeyboardAwareScrollViewRef } from 'react-native-keyboard-controller';
import { KeyboardAware } from './KeyboardAware';

type Props = {
  scrollIndicatorInsets?: Insets;
  scrollEnabled?: boolean;
  children: React.ReactNode;
  keyboardAvoiding?: boolean;
  contentContainerStyle?: StyleProp<ViewStyle>;
  contentPaddingTop?: number;
  contentPaddingBottom?: number;
  backgroundColor?: string;
  onLayout?: KeyboardAwareScrollViewProps['onLayout'];
  onScroll?: KeyboardAwareScrollViewProps['onScroll'];
  scrollViewRef?: React.RefObject<KeyboardAwareScrollViewRef | null>;
  withSafeAreaBottom?: boolean;
  withSafeAreaTop?: boolean;
  withSafeAreaLeft?: boolean;
  withSafeAreaRight?: boolean;
  gap?: number;
};

export const ScrollView = ({
  scrollIndicatorInsets,
  scrollEnabled,
  children,
  keyboardAvoiding,
  contentContainerStyle,

  contentPaddingTop = theme.paddingPageVertical,
  contentPaddingBottom = theme.paddingPageVertical,
  gap = theme.paddingPageVertical,

  backgroundColor,
  onLayout,
  onScroll,
  scrollViewRef,
  withSafeAreaTop = true,
  withSafeAreaBottom = true,
  withSafeAreaLeft = true,
  withSafeAreaRight = true,
}: Props): React.ReactElement => {
  return (
    <KeyboardAware
      scrollView
      scrollEnabled={scrollEnabled}
      scrollIndicatorInsets={scrollIndicatorInsets}
      keyboardAvoiding={keyboardAvoiding}
      withSafeAreaTop={withSafeAreaTop}
      withSafeAreaBottom={withSafeAreaBottom}
      withSafeAreaLeft={withSafeAreaLeft}
      withSafeAreaRight={withSafeAreaRight}
      contentPaddingTop={contentPaddingTop}
      contentPaddingBottom={contentPaddingBottom}
      scrollViewContentContainerStyle={contentContainerStyle}
      gap={gap}
      backgroundColor={backgroundColor}
      onLayout={onLayout}
      onScroll={onScroll}
      scrollViewRef={scrollViewRef}
    >
      {children}
    </KeyboardAware>
  );
};
